import * as yup from 'yup';
import { AreaOptions } from './Data.conf';

export const FilterConf = {
  schema: yup.object({
    area: yup.array().nullable(),
  }),
  initialState: {
    value: {
      area: null,
    },
  },
  fields: [
    {
      id: 'area',
      name: 'area',
      type: 'autocomplete_multiple',
      label: 'Area',
      options: AreaOptions,
      required: false,
      xs: 12,
      sm: 6,
      md: 4,
    },
  ],
  query: {
    keys: [
      {
        key: 'area',
        value: 'area.id',
        operator: '$eq',
      },
    ],
  },
};
